// extracted by mini-css-extract-plugin
export var box = "_4w-2";
export var checkboxControl = "_4w-0";
export var checkboxRow = "_4w-a";
export var checked = "_4w-3";
export var descriptionSpacer = "_4w-c";
export var disabled = "_4w-4";
export var icon = "_4w-8";
export var input = "_4w-1";
export var labelSpacer = "_4w-b";
export var large = "_4w-7";
export var medium = "_4w-6";
export var small = "_4w-5";
export var text = "_4w-9";